import { IAddressBase } from '../../models/address';
import { IUserCategoryBase } from '../../models/userCategories';
import {
  IUserAddressBase,
  IUserAssignmentBase,
  IUserBase,
  IUserOnboardBase,
  UserGender,
} from '../../models/users';
import { IVentureBase } from '../../models/ventures';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface IUserAssignment extends IUserAssignmentBase {
  venture?: IVentureBase;
}

export interface INewUser extends IUserBase {
  address?: IUserAddressBase;
  categories: IUserCategoryBase[];
  onboards: IUserOnboardBase[];
  userAssignments: IUserAssignment[];
}

interface ICreateUserProps {
  address?: IAddressBase;
  bio?: string;
  birthDate?: Date;
  categoriesId?: string[];
  cpf?: string;
  cnpj?: string;
  companyName?: string;
  email?: string;
  featureGroupId?: string;
  featureGroupKey?: string;
  gender?: UserGender;
  healthCheck?: Date;
  hostId?: string;
  name: string;
  foreignerDocument?: string;
  foreignerDocumentType?: string;
  useForeignerDocument?: boolean;
  phone?: string;
  tradeName?: string;
  venturesId?: string[];
}
export const createUsersService = async ({
  address,
  bio,
  birthDate,
  categoriesId,
  cpf,
  cnpj,
  companyName,
  email,
  featureGroupId,
  featureGroupKey,
  gender,
  healthCheck,
  hostId,
  name,
  foreignerDocument,
  foreignerDocumentType,
  useForeignerDocument,
  phone,
  tradeName,
  venturesId,
}: ICreateUserProps): Promise<INewUser> => {
  const { data } = await jhsfBookingsApi.post<INewUser>('/v2/users', {
    address,
    bio,
    birthDate,
    categoriesId,
    cpf,
    cnpj,
    companyName,
    email,
    featureGroupId,
    featureGroupKey,
    gender,
    healthCheck,
    hostId,
    name,
    foreignerDocument,
    foreignerDocumentType,
    useForeignerDocument,
    phone,
    tradeName,
    venturesId,
  });

  return data;
};
